import RepositoryService from 'src/services/repository'

const resource = 'operation'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  patchMany: (idList, newValues) => RepositoryService.crud.patch(`${resource}/many`, { idList, newValues }),
  deleteOne: id => RepositoryService.base.deleteOne(`${resource}/${id}`),
}
